import { render, staticRenderFns } from "./PropertyText.vue?vue&type=template&id=ad811c36&scoped=true"
import script from "./PropertyText.vue?vue&type=script&lang=js"
export * from "./PropertyText.vue?vue&type=script&lang=js"
import style0 from "./PropertyText.vue?vue&type=style&index=0&id=ad811c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad811c36",
  null
  
)

export default component.exports